// eslint-disable-next-line import/no-anonymous-default-export
export default {
    privacy_policy_url:"https://legal.encore.fans/Encore_Privacy_Policy.pdf",
    term_of_service_url:"https://legal.encore.fans/Encore_Terms_Conditions.pdf",
    orlando_rules_url: "https://drive.google.com/file/d/1tRHJ_p06PcPCcplJO2KHsMEvqEPx2NGj/view"
}